export default __webpack_public_path__ + "static/media/division-6.048383ac.png";